import {
  TRUCK_YARD_GUARD_ROLE_ID,
  TRUCK_YARD_INSPECTOR_ROLE_ID,
  TRUCK_YARD_SUPERVISOR_ROLE_ID,
} from "../../../hooks/useTruckYardRole";

/**
 * Operadores de patio: los mismos ids que `YARD_OPERATOR_ROLE_IDS` de
 * `hikvisionAccessAuthz.js` en el backend. Sin gate por compañía, igual que
 * allá: el servidor los veta por el id del rol, sea cual sea su empresa.
 */
const YARD_OPERATOR_ROLE_IDS = new Set([
  TRUCK_YARD_GUARD_ROLE_ID,
  TRUCK_YARD_INSPECTOR_ROLE_ID,
  TRUCK_YARD_SUPERVISOR_ROLE_ID,
]);

/**
 * ¿Puede este rol cambiar el ID de control de acceso de un vehículo?
 * `PUT /truck-yard/vehicle` responde 403 si un operador lo cambia (dar de alta
 * o re-apuntar una tarjeta es la misma política que `/accessCard`); sí puede
 * reasignar patios con el mismo tag.
 */
export function canEditAccessControlId(roleId: string | null | undefined): boolean {
  return !roleId || !YARD_OPERATOR_ROLE_IDS.has(roleId);
}

export type AssignVehicleErrorKey =
  | "vehicles.assignErrors.forbidden"
  | "vehicles.assignErrors.tagInUse"
  | "vehicles.assignErrors.reservedSpecialTag"
  | "vehicles.assignErrors.notFound"
  | "vehicles.assignErrors.generic";

/** Clave i18n (namespace truckYard) del error de guardar la asignación. */
export function assignVehicleErrorKey(error: unknown): AssignVehicleErrorKey {
  const response = (
    error as {
      response?: { status?: number; data?: { meta?: { message?: unknown } } };
    } | null
  )?.response;
  const status = response?.status;
  if (status === 403) return "vehicles.assignErrors.forbidden";
  if (status === 409) {
    // Dos 409 distintos desde los tags especiales: el de siempre (el tag ya es
    // de otra unidad) y `CardReservedAsSpecialTag` (el tag es el de proveedores
    // o el de pipas sin tag de un patio). Con un solo texto, al segundo se le
    // decía "ya es la tarjeta de otro vehículo o conductor", que es falso y
    // manda a buscar una unidad que no existe.
    return response?.data?.meta?.message === "CardReservedAsSpecialTag"
      ? "vehicles.assignErrors.reservedSpecialTag"
      : "vehicles.assignErrors.tagInUse";
  }
  if (status === 404) return "vehicles.assignErrors.notFound";
  return "vehicles.assignErrors.generic";
}
